import React, { Component } from 'react';
import twitter from '../../assets/images/footer-icons/twitter-icn.svg';
import insta from '../../assets/images/footer-icons/instagram-icon.svg';
import instap from '../../assets/images/footer-icons/instagram-icn.svg';
import twitterp from '../../assets/images/footer-icons/twitter-icn-green.svg';
import i18next from 'i18next';

function FooterHover(props) {
    return (
        <div
            className={`ace-footer fixed-bottom ${
                i18next.language === 'en' ? 'mr-0 en-ace-footer' : ''
            }`}
        >
            <a
                href='https://twitter.com/acesaudiorg'
                target='_blank'
                rel='noopener noreferrer'
            >
                {props.white ? (
                    <img src={twitter} alt='twitter' />
                ) : (
                    <img src={twitterp} alt='twitter' />
                )}
            </a>
            <a
                href='https://www.instagram.com/acesaudiorg'
                target='_blank'
                rel='noopener noreferrer'
            >
                {props.white ? (
                    <img src={insta} alt='instagram' />
                ) : (
                    <img src={instap} alt='instagram' />
                )}
            </a>
        </div>
    );
}

export default FooterHover;
